import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Center,
  Text
} from "@chakra-ui/react";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";

const FAQ = () => {
  return (
    <>
      <Header />

      <Center
        pt={["30px", "72px"]}
        height={["320px", "350px", "400px"]}
        bgColor="#2F2963"
        width="100%"
        textAlign="center"
        position={"relative"}
      >
        <Text color="white" fontSize={["42px", "48px"]} fontWeight="800">
          Frequently <br />
          Asked <br />
          Questions
        </Text>
      </Center>
      <Box
        width="100%"
        bg="#F9F9F9"
        justifyContent="center"
        alignContent="center"
        height="auto"
        paddingY="3.2rem"
      >
        <Box
          width="80%"
          bg="white"
          height="fit-content"
          padding="1.2rem"
          margin="0 auto"
          paddingTop="3rem"
          paddingBottom="3rem"
        >
          {/* <InputGroup
            color="brand.subtitle"
            bg="white"
            borderRadius="12px"
            width="30%"
            marginLeft="2.4rem"
            //   placeholder="Search"
          >
            <Input height="3rem" placeholder="Search" fontSize={14} size="sm" />
            <InputRightElement
              cursor="pointer"
              pointerEvents="none"
              children={<RiSearch2Line color="red" size="1.2rem" />}
            />
          </InputGroup> */}
          <Box
            paddingTop="2.2rem"
            paddingX="2.2rem"
            width="100%"
            fontSize="14px"
            fontWeight="600"
            lineHeight="22px"
          >
            <Accordion  allowMultiple>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      WHAT CATEGORIES OF TRAINING ARE AVAILABLE
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  We have the short-term courses and long-term courses. the
                  short- term courses are for like minimum of 1 week - a month,
                  while the long-term course is a 1 year course for only
                  electrical and mechanical engineers and its called NGSDP
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      WHAT IS THE CRITERION FOR POSTING PARTICIPANTS TO THE
                      VARIOUS TRAINING CENTRES ACROSSS THE COUNTRY?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    1. Training Center of Choice during Application Submission
                  </Text>
                  <Text> 2. Availability of Slots at Training Centres</Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      IS THERE ACCOMODATION ON SITE (AT THE TRAINING CENTRES)
                      THAT PARTICIPANTS CAN PAY FOR?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    Details on Accommodation is always made known to Trainees
                    during the Orientation period before Course Commencement
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      WHAT IS NAPTIN ALL ABOUT?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    NAPTIN stands for National Power Training Institute of
                    Nigeria.{" "}
                  </Text>
                  <Text>
                    The Federal Ministry of Power under the leadership of former
                    Hon. Minister of Power- Dr. Rilwan Lanre Babalola
                    established NAPTIN in 2009 as the Official Trainer of the
                    Power Sector. This was aimed at closing the skill gap and
                    meeting up with Training Requirements of the Power Sector.
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      WHERE IS NAPTIN HEAD QUARTERS LOCATED?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    NAPTIN Head Quarters is located at: Plot 1124, Eldoret
                    close, Off Aminu Kano Crescent, Wuse 2, FCT Abuja.{" "}
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      WHAT IS RTC?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    RTC refers to Regional Training Centers. NAPTIN has 8
                    Regional Training Centers (RTC):
                    <br />
                    (i) RTC Afam - Rivers State
                    <br />
                    (ii) RTC Akangba - Lagos State
                    <br />
                    (iii) RTC Ijora - Lagos Statev (iv) RTC Jos - Plateau State
                    <br />
                    (v) RTC Kaduna - Kaduna State
                    <br />
                    (vi) RTC Kainji - Niger State
                    <br />
                    (vii) RTC Kano - Kano state
                    <br />
                    (viii) RTC Oji - Enugu State
                    <br />
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      WHAT CATEGORIES OF TRAINING ARE AVAILABLE?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    NAPTIN Training are categorized into:
                    <br />
                    Technical Courses
                    <br />
                    Non-Technical Courses
                    <br />
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      HOW DOES NAPTIN GET ITS TRAINING RESOURCE
                      PERSONNEL/INSTRUCTORS?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    NAPTIN gets its Training Resource Personnel/Instructors from
                    Local/International, Serving/Retired Seasoned and
                    Experienced Engineers.
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      HOW DO I APPLY FOR A NAPTIN TRAINING?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    Trainees can apply for Training by doing the following:{" "}
                    <br />
                    (i) Login to the NAPTIN TMIS Portal or Signup if you do not
                    have a portal account.
                    <br />
                    (ii) Upon successful login, a dashboard is provisioned for
                    you that you can navigate to view courses to apply for.
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      WHO ARE THE TARGET BENEFICIARIES OF NAPTIN TRAINING?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    NAPTIN Trainings are designed for individuals and
                    organisations who desire a career in the Power Sector.
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      DOES NAPTIN ACCEPT INDUSTRIAL TRAINING PLACEMENT?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    Yes, NAPTIN Accepts Industrial Training Placements; however,
                    this is dependent on number of free slots available.
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      WHAT IS THE NAPTIN TMIS?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    The NAPTIN TMIS (Training Management Information System) is
                    an enterprise online software platform developed for the
                    automation, consolidation, and management of data on all
                    NAPTIN Training activities and processes. The Portal serves
                    as a central tool for Trainees, Instructors, Organisations
                    (Private & Government) and NAPTIN to collaborate with
                    respect to NAPTIN Trainings.
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      WHAT ARE THE BENEFITS OF THE NAPTIN TMIS?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    There are numerous benefits of the NAPTIN TMIS. Some of
                    these benefits include but are not limited to the following:
                    <br />
                    - Full Training Mgmt Automation.
                    <br />
                    - Centralized Portal System.
                    <br />
                    - Online Training Advert and Appl
                    <br />
                    ication. - Online Payment and Verification.
                    <br />
                    - Single Click & On-demand Reports.
                    <br />
                    - Electronic Data Storage.
                    <br />
                    - Online Helpdesk and Support.
                    <br />
                    - Better Service Delivery.
                    <br />
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      HOW DO I CONTACT THE NAPTIN TMIS SUPPORT TEAM?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    You can contact the NAPTIN Support Team via Email on
                    support@naptinportal.com
                  </Text>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      HOW DO I TRACK STATUS OF A SUPPORT REQUEST?
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text>
                    {" "}
                    (i)Go to the Support Page of the NAPTIN TMIS Portal.
                    <br />
                    (ii)Click on the 'Check Request Status' link/button, this
                    should navigate you to the Check Request Status Form.
                    <br />
                    (iii)Fill the form appropriately and click on the 'Check
                    Status' button.
                    <br />
                  </Text>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
};
export default FAQ;
